import DetailPage from './DetailPage';

export default DetailPage;
